import logger from './logger'
import sasad from './ads/sas/sas'
import outbrain from './ads/outbrain/outbrain'
import ReviveBanner from "../widgets/revive-banner";
import revive from './ads/revive/revive'

const ads = {}

/**
 * Custom sas events logic for this project
 */
const sasEvents = {
    beforeRender: (data) => {
        var element = $('#sas_' + data.formatId);

        if (typeof MutationObserver !== 'undefined') {
            var observer = new MutationObserver(function () {
                $(window).trigger('cs:bannerLoad');
            });
            observer.observe(element.get(0), {
                attributes: false,
                childList: true,
                characterData: false
            });
        } else {
            $(element).on('DOMSubtreeModified', function () {
                $(window).trigger('cs:bannerLoad');
                $(element).off('DOMSubtreeModified');
            });
        }

        $('body').addClass('top-banner-f3');
    },
    onLoad: (data) => {
        setTimeout(function () {
            $(window).trigger('cs:bannerLoad');
        }, 400);
    },
    onError: (data) => {
        setTimeout(function () {
            $(window).trigger('cs:bannerLoad');
        }, 400);

        var element = $('#sas_' + data.formatId);

        if (element.length !== 0) {
            element.remove();
        }
    },
}

/**
 * Method to inject ads scripts into the dom
 */
const handleDomInjections = () => {
    // sasad.domInjection(
    //     'https://ced.sascdn.com/tag/1778/smart.js',
    //     '//tagmanager.smartadserver.com/1778/96478/smart.prebid.js'
    // )
    // outbrain.domInjection()

    // More injection should be here
    revive.domInjection('//ads.comitium.io/www/delivery/asyncjs.php');
}

/**
 * Method to handle (initialize/push) sas banners
 */
const handleSas = () => {
    if (!window.sas) {
        logger.log("No Sas instance available")
        return
    }

    $('cs-ads').each((_idx, el) => {
        const {
            siteId,
            pageId,
            formatId,
            target,
            events
        } = $(el).data()

        const smartEvents = (!events || events === 'enabled') ? sasEvents : {}
        const props = {
            siteId,
            pageId,
            formatId,
            target
        }

        sasad.push(props, smartEvents)
    })
}

/*
    Method to load revive banners
 */
const handleRevive = () => {
    $('[data-id="revive-banner"]').each(function () {
        new ReviveBanner(this);
    });
    $('cs-ads').each((_idx, el) => {
        const {
            reviveZoneId,
            reviveId,
            condition
        } = $(el).data();

        if (condition !== "" && condition !== undefined && !eval(window.innerWidth + condition)) {
            return;
        }

        let ins = document.createElement('ins');

        ins.setAttribute('data-revive-zoneid', reviveZoneId);
        ins.setAttribute('data-revive-id', reviveId);

        if ($(el).data('reviveBlockBanner')) {
            ins.setAttribute('data-revive-block', $(el).data('reviveBlockBanner'));
        }
        if ($(el).data('reviveBlockCampaign')) {
            ins.setAttribute('data-revive-blockcampaign', $(el).data('reviveBlockCampaign'));
        }

        el.appendChild(ins);
    });
}

ads.init = () => {
    handleRevive();
    handleDomInjections();
}

ads.remove = () => {
    $('cs-ads').each(function () {
        $(this).remove();
    });
    $('[data-id="revive-banner"]').each(function () {
        $(this).removeAttr("data-banner");

    });
}

export default ads